import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { callApi } from "../utils/ApiCallPostOnly";

export const useRequestList = ({ type, search, page }) => {
  const filter = {
    filter: {
      noFilter: null,
      branchFilter: type === "approvals" ? "MyApprovals" : "Mine",
      Approvals: type === "draft" ? false : true,
      searchTerm: search,
    },
    paging: { pageIndex: page },
  };

  return useQuery({
    queryKey: ["orderListState", type, filter],
    queryFn: async () =>
      callApi({
        path: "draftorderlist",
        command: "",
        data: JSON.stringify({ list: filter }),
      }),
    placeholderData: keepPreviousData,
    staleTime: 5000,
  });
};
